import { driveItemKeyFacet } from '../models/keys/DriveItemKeyFacet';
import { getUrlParts } from '@ms/odsp-graph/lib/base/urlHelper/UrlHelper';
import { Key } from '@ms/items-view/lib/private/models/KeyFacet';

export function getDriveItemKey(itemUrl: string): typeof driveItemKeyFacet.type | undefined {
  const {
    endpoint,
    driveId,
    itemId
  } = getUrlParts(itemUrl);

  if (!endpoint) {
    return undefined;
  }

  return {
    endpoint,
    driveId,
    itemId
  };
}

export function getEndpointVersionKeyAliases(driveItemKey: typeof driveItemKeyFacet.type): Key<typeof driveItemKeyFacet.type>[] {
  const itemKeys: Key<typeof driveItemKeyFacet.type>[] = [];

  itemKeys.push(driveItemKeyFacet.serialize(driveItemKey));

  const { endpoint } = driveItemKey;

  const isV20 = endpoint.indexOf('/v2.0') > -1;
  const isV21 = endpoint.indexOf('/v2.1') > -1;

  if (isV20 || isV21) {
    // this endpoint is for a v2.0 or v2.1
    // depending on the features enabled, .driveUrl in the list schema could be a different from the item url
    // we should map the other version too
    itemKeys.push(driveItemKeyFacet.serialize({
      ...driveItemKey,
      endpoint: isV21 ? endpoint.replace('/v2.1', '/v2.0') : endpoint.replace('/v2.0', '/v2.1')
    }));
  }

  return itemKeys;
}
